import React from 'react';
import { shape } from 'prop-types';
import { loadable, LazyHydrate as Hydrator } from 'nordic/lazy';
import View from '../view';
import Onboarding from '../../features/onboarding/onboarding.mobile';

import KYCNotification from '../../features/kyc-notification/kyc-notification.mobile';
import Gallery from '../../features/gallery/gallery.mobile';
import Grid from '../../../../../components/grid';

// Snackbar
import Snackbar from '../../features/snackbar';

// Content Bottom

import Denounce from '../../features/denounce';

import BillboardAdn from '../../features/billboard-adn/billboard-adn-bottom';

import DateAgreementSummary from '../../features/date-agreement-summary/date-agreement-summary.mobile';
import PaymentSummary from '../../features/payment-summary/payment-summary.mobile';
import BuyProtectedSummary from '../../features/buy-protected-summary/buy-protected-summary.mobile';

const ItemStatusMessageHead = loadable(() => import('../../features/item-status/head'));
const Header = loadable(() => import('../../features/header/header.mobile'));
const Price = loadable(() => import('../../features/price/price.mobile'));
const ItemStatusShortDescription = loadable(() => import('../../features/item-status/short-description'));
const GroupedMainActions = loadable(() => import('../../features/grouped-main-actions'));
const GroupedShareBookmark = loadable(() => import('../../features/grouped-share-bookmark'));
const GiftRegistry = loadable(() => import('../../features/gift-registry'));
const BuyBenefits = loadable(() => import('../../features/buy-benefits/buy-benefits.mobile'));
const ReportProblem = loadable(() => import('../../features/report-problem/report-problem.mobile'));
const SellerProfile = loadable(() => import('../../features/seller-profile/seller-profile.mobile'));
const SellerReputation = loadable(() => import('../../features/seller-reputation/seller-reputation'));
const ServiceFaq = loadable(() => import('../../features/service-faq/service-faq'));
const AllFeatures = loadable(() => import('../../features/all-features/all-features.mobile'));
const Description = loadable(() => import('../../features/description/description.mobile'));
const Location = loadable(() => import('../../features/location/location.mobile'));
const PaymentMethods = loadable(() => import('../../features/payment-methods/payment-methods.mobile'));
const ReviewsCapability = loadable(() => import('../../../../../components/reviews-capability/reviews.mobile'));
const SecurityTips = loadable(() => import('../../features/security-tips/security-tips.mobile'));
const RelatedServices = loadable(() => import('../../features/related-services'));

const HirableServicesMobile = props => (
  <View {...props} vertical="hirable-services">
    <Grid.Container className="ui-pdp-container--top">
      {/* Head Section */}
      <Onboarding />
      <Hydrator whenVisible>
        <ItemStatusMessageHead />
      </Hydrator>
      <Hydrator whenVisible>
        <KYCNotification />
      </Hydrator>
      {/* Hero */}
      <Hydrator whenIdle>
        <Header />
      </Hydrator>
      <Gallery />
      {/* Short Description */}
      <Hydrator whenVisible>
        <Price />
      </Hydrator>
      <Hydrator whenVisible>
        <DateAgreementSummary />
      </Hydrator>
      <Hydrator whenVisible>
        <PaymentSummary />
      </Hydrator>
      <Hydrator whenVisible>
        <BuyProtectedSummary />
      </Hydrator>
      <Hydrator whenVisible>
        <ItemStatusShortDescription />
      </Hydrator>
      <Hydrator whenVisible>
        <GroupedMainActions />
      </Hydrator>
      <Hydrator whenVisible>
        <BuyBenefits />
      </Hydrator>
      <Hydrator whenVisible>
        <ReportProblem />
      </Hydrator>
      <Hydrator whenVisible>
        <GiftRegistry />
        <GroupedShareBookmark />
      </Hydrator>
      <Hydrator whenVisible>
        <SellerProfile />
      </Hydrator>
      <Hydrator whenVisible>
        <SellerReputation />
      </Hydrator>
      <Hydrator whenVisible>
        <AllFeatures />
      </Hydrator>
      <Hydrator whenVisible>
        <Description className="pl-16 pr-16" />
      </Hydrator>
      <Hydrator whenVisible>
        <Location />
      </Hydrator>
      <Hydrator whenIdle>
        <RelatedServices />
      </Hydrator>
      <Hydrator whenVisible>
        <PaymentMethods />
      </Hydrator>
      <Hydrator whenVisible>
        <ReviewsCapability />
      </Hydrator>
      <Hydrator whenVisible>
        <ServiceFaq />
      </Hydrator>
      <Hydrator whenVisible>
        <SecurityTips />
      </Hydrator>
      {/* Content Bottom */}
      <Hydrator whenVisible>
        <Denounce />
      </Hydrator>
      <Hydrator ssrOnly>
        <BillboardAdn />
      </Hydrator>
      <Hydrator whenVisible>
        <Snackbar />
      </Hydrator>
    </Grid.Container>
  </View>
);

HirableServicesMobile.propTypes = {
  initialState: shape().isRequired,
};

export default HirableServicesMobile;
